<template>
  <div class="fixed inset-0 overflow-hidden bg-black flex flex-col">

    <div class="pt-8 pb-10 z-10 flex-shrink-0 flex justify-center">
      <router-link to="/" class="outline-none block">
        <img
          src="https://assets.earthpbc.com/earth-shield-400x100.png"
          alt="[Protect Earth]"
          class="w-[200px] h-auto"
        />
      </router-link>
    </div>

    <div class="w-full flex-1 min-h-0 flex items-center justify-center px-14">
      <slot />
    </div>

    <div class="w-full h-[200px] flex-shrink-0 overflow-hidden pointer-events-none">
      <img
        src="https://assets.earthpbc.com/nasa-desktop.jpg"
        alt=""
        class="w-full h-full object-cover"
        style="object-position: center 20%;"
      />
    </div>

  </div>
</template>
